export const getUrl = (path: string) => {
  if (process.env.NODE_ENV === 'development') {
    return `/${path}`.replace('//', '/')
  }

  return `${process.env.PUBLIC_URL}${path}`
}
